export default __webpack_public_path__ + "static/media/Snd_s2.bb11964c.mp3";